<template>
  <div class="d-flex flex-column karte-page">
    <div :class="['d-flex', 'karte-content', { 'karte-content--with-action-bar': showKarte }]">
      <v-container
        fluid
        class="karte karte-container"
        :class="{
          'px-2': !isSidebarWidthMin,
        }"
      >
        <div
          v-if="errorMessage != null"
          class="pink--text"
        >
          {{ errorMessage }}
        </div>
        <v-row
          :dense="!isSidebarWidthMin"
          style="height: 100%;"
        >
          <v-col
            v-if="reservation.loading"
            class="col-md-12 text-center"
            style="background-color: #ffffff"
          >
            <v-img src="/loading.gif" />
          </v-col>
          <v-col
            v-if="!reservation.loading"
            class="karte-scroll-area-y"
            md="2"
          >
            <period-list />
          </v-col>
          <v-col
            v-if="showNoReservationMessage && !reservation.loading && !viewableKarte()"
            class="karte-scroll-area-y"
          >
            <p
              class="text-center"
              style="font-size: 2rem; color: #808080;"
            >
              このルームでは、本日の予約はまだありません。
            </p>
            <v-container class="mt-0 pt-0 white">
              <v-row style="max-width:40rem; margin: 2rem auto 0 auto; background-color: white;">
                <v-col
                  cols="12"
                  class="d-flex flex-row justify-center"
                >
                  <p class="text-md-center text-pink">
                    ※ 運営からのお知らせ ※
                  </p>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex flex-row justify-center"
                >
                  <p
                    class="karte-reference-content"
                    style="white-space: pre-wrap; line-height: 25px;"
                    v-html="karteReferenceInfo.content"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            v-if="showKarte"
            :md="6"
            class="karte-scroll-area-y"
          >
            <div class="karte-detail pa-2">
              <v-row class="pa-4 pt-1 pb-0">
                <v-col>
                  <h1 style="font-size: 2em; font-weight: bold;">
                    {{ reservation.date }} {{ reservation.time }}
                  </h1>
                </v-col>
              </v-row>
              <!-- 事前問診情報 -->
              <v-row>
                <v-container
                  fluid
                  class="pa-7"
                >
                  <v-row
                    noguide
                    no-gutters
                  >
                    <v-col>
                      <p class="mb-0">
                        事前問診
                      </p>
                    </v-col>
                  </v-row>
                  <v-row
                    noguide
                  >
                    <v-col
                      sm="12"
                      md="12"
                      style="
                      border: solid 1px #bdbdbd;
                      border-bottom: none;
                      padding: 0;
                    "
                    >
                      <v-tooltip
                        v-model="procedureTooltipOpen"
                        :open-on-hover="true"
                        :open-on-click="false"
                        :open-on-focus="false"
                        :disabled="!procedureTooltipLines"
                        content-class="procedure-tooltip-content"
                      >
                        <template #activator="{ props }">
                          <v-btn
                            v-bind="props"
                            :color="changeColorByTool()"
                            class="font-weight-bold"
                            theme="dark"
                            flat
                          >
                            {{ reservation.tool }}
                          </v-btn>
                        </template>
                        <div v-if="procedureTooltipLines">
                          <div class="font-weight-bold procedure-tooltip-title">
                            {{ procedureTooltipTitle }}
                          </div>
                          <div
                            v-for="(tooltipLine, index) in procedureTooltipLines"
                            :key="index"
                          >
                            {{ tooltipLine }}
                          </div>
                        </div>
                      </v-tooltip>
                      {{ reservation.doctor }}
                    </v-col>
                  </v-row>
                  <v-row
                    noguide
                  >
                    <v-col
                      sm="6"
                      md="6"
                      style="border: solid 1px #bdbdbd; border-right: none"
                      class="pt-0 pb-0 pl-0 pr-0"
                    >
                      <v-card
                        :flat="true"
                        ripple
                        style="border-radius: 0"
                      >
                        <v-card-text>
                          <div v-if="reservation.department_type == 1">
                            <template v-if="reservation.userType == 'ParentUser'">
                              <syounikaUserInfo :reservation="reservation" />
                            </template>
                            <template v-if="reservation.userType == 'YouthUser'">
                              <youthUserInfo :reservation="reservation" />
                            </template>
                          </div>
                          <div v-if="reservation.department_type >= 2">
                            <obstetricsUserInfo :reservation="reservation" />
                          </div>
                          <ConsultationAttentionNotice
                            :has-special-note="attentionFlags.hasSpecialNote"
                            :has-municipal-cooperation-history="attentionFlags.hasMunicipalCooperationHistory"
                          />
                          <div>
                            <span> <b>相談方法別の利用可否</b>: </span>
                            <div>
                              <v-chip
                                class="ma-1"
                                label
                                :color="reservation.useReservation ? 'red' : 'default'
                                "
                              >
                                <span class="text-black">夜間</span>
                                <v-icon
                                  v-if="reservation.useReservation"
                                  color="rgba(0, 0, 0, .54)"
                                  size="small"
                                  end
                                >
                                  mdi-circle-outline
                                </v-icon>
                                <v-icon
                                  v-if="!reservation.useReservation"
                                  size="small"
                                  end
                                >
                                  mdi-close
                                </v-icon>
                              </v-chip>
                              <v-chip
                                class="ma-1"
                                label
                                :color="reservation.useAnytimeConsultation
                                  ? 'red'
                                  : 'default'
                                "
                              >
                                <span class="text-black">いつでも</span>
                                <v-icon
                                  v-if="reservation.useAnytimeConsultation"
                                  color="rgba(0, 0, 0, .54)"
                                  size="small"
                                  end
                                >
                                  mdi-circle-outline
                                </v-icon>
                                <v-icon
                                  v-if="!reservation.useAnytimeConsultation"
                                  size="small"
                                  end
                                >
                                  mdi-close
                                </v-icon>
                              </v-chip>
                              <v-chip
                                class="ma-1"
                                label
                                :color="reservation.useDaytimeAdvice
                                  ? 'red'
                                  : 'default'
                                "
                              >
                                <span class="text-black">日中助産師</span>
                                <v-icon
                                  v-if="reservation.useDaytimeAdvice"
                                  color="rgba(0, 0, 0, .54)"
                                  size="small"
                                  end
                                >
                                  mdi-circle-outline
                                </v-icon>
                                <v-icon
                                  v-if="!reservation.useDaytimeAdvice"
                                  size="small"
                                  end
                                >
                                  mdi-close
                                </v-icon>
                              </v-chip>
                            </div>
                          </div>
                          <div>
                            <span> <b>相談員種別の利用可否</b>: </span>
                            <div>
                              <v-chip
                                class="ma-1"
                                label
                                :color="reservation.pediatricianEnabled ? 'red' : 'default'
                                "
                              >
                                <span class="text-black">小児科医</span>
                                <v-icon
                                  v-if="reservation.pediatricianEnabled"
                                  color="rgba(0, 0, 0, .54)"
                                  size="small"
                                  end
                                >
                                  mdi-circle-outline
                                </v-icon>
                                <v-icon
                                  v-if="!reservation.pediatricianEnabled"
                                  size="small"
                                  end
                                >
                                  mdi-close
                                </v-icon>
                              </v-chip>
                              <v-chip
                                class="ma-1"
                                label
                                :color="reservation.obstetricsEnabled
                                  ? 'red'
                                  : 'default'
                                "
                              >
                                <span class="text-black">産婦人科医</span>
                                <v-icon
                                  v-if="reservation.obstetricsEnabled"
                                  color="rgba(0, 0, 0, .54)"
                                  size="small"
                                  end
                                >
                                  mdi-circle-outline
                                </v-icon>
                                <v-icon
                                  v-if="!reservation.obstetricsEnabled"
                                  size="small"
                                  end
                                >
                                  mdi-close
                                </v-icon>
                              </v-chip>
                              <v-chip
                                class="ma-1"
                                label
                                :color="reservation.midwifeEnabled
                                  ? 'red'
                                  : 'default'
                                "
                              >
                                <span class="text-black">助産師</span>
                                <v-icon
                                  v-if="reservation.midwifeEnabled"
                                  color="rgba(0, 0, 0, .54)"
                                  size="small"
                                  end
                                >
                                  mdi-circle-outline
                                </v-icon>
                                <v-icon
                                  v-if="!reservation.midwifeEnabled"
                                  size="small"
                                  end
                                >
                                  mdi-close
                                </v-icon>
                              </v-chip>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col
                      sm="6"
                      md="6"
                      style="border: solid 1px #bdbdbd"
                      class="pt-0 pb-0 pl-0 pr-0"
                    >
                      <v-card
                        :flat="true"
                        ripple
                        style="border-radius: 0"
                      >
                        <v-card-text>
                          <span><b>相談したいこと</b>： </span><br>
                          <div
                            v-if="hasQuestionList"
                            style="width: 80%; background-color: #ededed; margin: 4px 0; padding: 2px 4px 8px 4px; border-radius: 8px;"
                          >
                            <div style="display: flex; justify-content: flex-start; align-items: center;">
                              <p style="font-size: 12px; font-weight: bold;">
                                ユーザーへの質問リスト
                              </p>
                              <v-btn
                                :color="isOpen ? null : 'grey-darken-4'"
                                density="comfortable"
                                outlined
                                size="small"
                                @click="toggleQuestionList"
                              >
                                {{ isOpen ? "閉じる▲" : "開く▼" }}
                              </v-btn>
                            </div>
                            <ul
                              v-if="isOpen"
                              style="font-size: 12px; margin-left: 8px; margin-bottom: 8px; padding-left: 8px;"
                            >
                              <li
                                v-for="(question, index) in karte.questionList"
                                :key="index"
                              >
                                {{ question }}
                              </li>
                            </ul>
                            <p style="font-size: 10px;">
                              ※ユーザーの相談文に不明点がある場合、ご利用ください。
                            </p>
                          </div>
                          <div class="mt-4">
                            <span v-text="reservation.description" />
                          </div>
                          <consultation-warning-notice
                            v-if="isMidwifeTeensReservation"
                            :text="midwifeTeensWarningText"
                          />
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-row>
              <!--// 事前問診情報 -->

              <v-container
                fluid
                class="pa-0"
              >
                <v-row class="pa-0">
                  <v-col
                    md="12"
                    class="pa-2 px-4"
                  >
                    <karte-body
                      ref="body"
                      :active="editing"
                    />
                    <v-container class="mt-0 pt-0 white">
                      <v-row>
                        <v-col>
                          <p class="text-md-center text-pink">
                            ※ 運営からのお知らせ ※
                          </p>
                          <p
                            class="karte-reference-content"
                            style="white-space: pre-wrap; line-height: 25px;"
                            v-html="karteReferenceInfo.content"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                    <karte-operation-fields :active="editing" />
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-col>
          <v-col
            v-if="showKarte"
            md="4"
            class="karte-scroll-area-y"
          >
            <!--// チャット画面 -->
            <chat
              ref="chat"
              :message-disabled="!reservation.today || reservation.toolId == 'tel'
              "
              :chat-id="parseInt($route.query.reservation_id)"
              :department-type="reservation.department_type"
              log-type="karte"
              :coupon-name="reservation.coupon"
              :coupon-names="reservation.couponNames"
              :shift-doctor-id="reservation.shiftDoctorId"
            />
          </v-col>
        </v-row>
      </v-container>
      <reservation-sidebar
        v-if="showKarte"
        class="flex-grow-0 d-none d-sm-flex"
      />
    </div>
    <karte-action-bar
      v-if="showKarte"
      :settled="isBottomBarStatusSettled"
    >
      <template v-if="karte.load_finish">
        <template v-if="!editing">
          <v-btn
            color="#33B5B4"
            class="font-weight-bold"
            theme="dark"
            @click="startEditing()"
          >
            編集する
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            variant="outlined"
            color="#33B5B4"
            @click="cancel()"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="#33B5B4"
            class="font-weight-bold"
            theme="dark"
            @click="postKarte()"
          >
            保存する
          </v-btn>
        </template>
      </template>
      <template v-else>
        <v-btn
          disabled
          tile
        >
          カルテ読込中...
        </v-btn>
      </template>
      <risk-assessment-bar-action
        :editable="riskAssessmentStatus?.editable ?? true"
        :editable-until-label="riskAssessmentEditableUntilLabel"
        @open="openRiskAssessment()"
      />
      <high-risk-report-bar-action
        :reportable="highRiskReportStatus.reportable"
        :risk-assessment-required="highRiskReportStatus.riskAssessmentRequired"
        @open="openHighRiskReport()"
      />
    </karte-action-bar>

    <!-- リスクアセスメント入力。入力途中の内容は本インスタンスが保持するため、
         画面滞在中は unmount させない。 -->
    <risk-assessment-launcher
      v-if="showKarte"
      ref="riskAssessmentLauncher"
      consultable-type="Reservation"
      :consultable-id="String($route.query.reservation_id)"
      @status-changed="riskAssessmentStatus = $event"
      @settled-changed="riskAssessmentSettled = $event"
      @report-requested="openHighRiskReport($event)"
    />

    <!-- ハイリスク疑いの報告。サンクス画面からの導線（@report-requested）もここへ繋ぐ。 -->
    <high-risk-report-launcher
      v-if="showKarte"
      ref="highRiskReportLauncher"
      consultable-type="Reservation"
      :consultable-id="String($route.query.reservation_id)"
      @status-changed="highRiskReportStatus = $event"
      @settled-changed="highRiskReportSettled = $event"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ondutyReservationViewLimitMixin from "../mixins/onduty_reservation_view_limit.js";
import loadStateMixin from "../mixins/load_state.js";
import procedureTooltipMixin from "../mixins/procedure_tooltip.js";
import { useBottomBarStatusSettled } from "../features/bottom-bar-status";
import PeriodList from "./shared/PeriodList.vue";
import KarteBody from "./shared/KarteBody.vue";
import Chat from "./shared/Chat.vue";
import KarteOperationFields from "./shared/KarteOperationFields.vue";
import KarteActionBar from "./shared/KarteActionBar.vue";
import SyounikaUserInfo from "./shared/karte/SyounikaUserInfo.vue";
import YouthUserInfo from "./shared/karte/SyounikaYouthUserInfo.vue";
import ObstetricsUserInfo from "./shared/karte/ObstetricsUserInfo.vue";
import ConsultationWarningNotice from "./shared/ConsultationWarningNotice.vue";
import { ReservationSidebar } from "@/vue/widgets/reservation-sidebar";
import { RiskAssessmentLauncher } from "@/vue/widgets/risk-assessment";
import RiskAssessmentBarAction from "./shared/RiskAssessmentBarAction.vue";
import { HighRiskReportLauncher } from "@/vue/widgets/high-risk-report";
import HighRiskReportBarAction from "./shared/HighRiskReportBarAction.vue";
import { ConsultationAttentionNotice, fetchConsultationAttentionFlags, EMPTY_CONSULTATION_ATTENTION_FLAGS } from "@/vue/entities/consultation-attention";
import { resetSessionTimeoutActivity } from "../features/session-timeout";

export default {
  name: "Karte",
  components: {
    PeriodList,
    KarteBody,
    Chat,
    KarteOperationFields,
    KarteActionBar,
    SyounikaUserInfo,
    YouthUserInfo,
    ObstetricsUserInfo,
    ConsultationWarningNotice,
    ReservationSidebar,
    RiskAssessmentLauncher,
    RiskAssessmentBarAction,
    HighRiskReportLauncher,
    HighRiskReportBarAction,
    ConsultationAttentionNotice
  },
  mixins: [ondutyReservationViewLimitMixin, loadStateMixin, procedureTooltipMixin],
  setup() {
    return useBottomBarStatusSettled();
  },
  data: () => ({
    editing: false,
    errorMessage: null,
    isOpen: false,
    // RiskAssessmentLauncher が GET /new から受け取った起動可否・修正可能期限。
    riskAssessmentStatus: null,
    highRiskReportStatus: { reportable: false, riskAssessmentAvailable: false, riskAssessmentRequired: false },
    attentionFlags: EMPTY_CONSULTATION_ATTENTION_FLAGS,
    // 相談切替時に先発の取得が後から完了して上書きしないよう、リクエストごとに採番して最新分のみ反映する
    attentionFlagsRequestId: 0,
  }),
  computed: {
    riskAssessmentEditableUntilLabel: function () {
      return this.riskAssessmentStatus?.editableUntilLabel ?? "";
    },
    ...mapGetters([
      "reservation",
      "karte",
      "currentDoctor",
      "reloadTimeoutId",
      "karteReferenceInfo",
      "karteUpdateResult",
      "isSidebarWidthMin",
      "roomReservationList",
      "hasAllCapabilities"
    ]),
    hasQuestionList() {
      return !this.isMidwifeTeensReservation && this.karte.questionList && this.karte.questionList.length > 0;
    },
    isMidwifeTeensReservation() {
      return Number(this.reservation?.department_type) === 3 && this.reservation?.inPregnancy === "teens";
    },
    midwifeTeensWarningText() {
      return "＜自死や被虐待のリスクが高いと判断された場合＞\n・信頼できる大人への相談を促してください。\n・可能な限り本人から本名、学校、生年月日を聞き出してください。\n・対応内容をカルテに記録し、運営にご報告ください。";
    },
    showNoReservationMessage() {
      if (!this.roomReservationList || this.roomReservationList.length === 0) {
        return false;
      }
      return this.roomReservationList.every(r => r.reserved === undefined || r.reserved === false);
    },
    // メインカラム・チャット・サイドバー・ボトムバーの表示条件（すべて同一）
    showKarte() {
      return !this.reservation.loading && this.reservation.date && this.viewableKarte();
    },
  },
  watch: {
    $route() {
      this.endEditing();
      this.clearData();
      this.fetchData();
    },
    "reservation.userId": {
      handler(userId) {
        if (userId != null) {
          this.findUser({ userId });
          this.fetchAttentionFlags(userId);
        } else {
          this.resetUser();
          this.attentionFlagsRequestId += 1;
          this.attentionFlags = EMPTY_CONSULTATION_ATTENTION_FLAGS;
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchData();
  },
  unmounted() {
    this.clearData();
  },
  methods: {
    // 担当・操作可能期間・学童以上の判定は Launcher 側が GET /new で行い、
    // 起動できない場合はスナックバーを出すため、ボタン側での活性判定は行わない。
    openRiskAssessment: function () {
      this.$refs.riskAssessmentLauncher.open();
    },
    // ボトムバーからは根拠アセスメントを指定せず、サーバーが返す直近の完了分を使う。
    // リスクアセスメント完了直後のサンクス画面からは riskAssessmentId 付きで呼ばれる。
    openHighRiskReport: function (payload) {
      this.$refs.highRiskReportLauncher.open(payload ?? {});
    },
    ...mapActions(["findUser", "resetUser"]),
    async fetchAttentionFlags(userId) {
      const requestId = ++this.attentionFlagsRequestId;
      this.attentionFlags = EMPTY_CONSULTATION_ATTENTION_FLAGS;
      let flags;
      try {
        flags = await fetchConsultationAttentionFlags(String(userId));
      } catch {
        // 取得失敗時は前ユーザーの注意情報を表示しない
        return;
      }
      if (requestId !== this.attentionFlagsRequestId) return;
      this.attentionFlags = flags;
    },
    clearData: function () {
      this.$store.dispatch("clearKarte");
      this.$store.dispatch("clearReservation");
      this.resetUser();
    },
    fetchData: function () {
      this.fetchReservation();
      this.fetchKarteReferenceInfo();
      if (this.$route.query.reservation_id != null) {
        this.fetchKarte();
        this.fetchRoom();
      }
    },
    fetchReservation() {
      this.$store.dispatch("findReservation", {
        reservationId: this.$route.query.reservation_id,
      });
    },
    fetchKarte() {
      this.$store.dispatch("findKarte", {
        reservationId: this.$route.query.reservation_id,
      });
    },
    fetchKarteReferenceInfo() {
      if (this.$route.query.reservation_id) {
        this.$store.dispatch("findKarteReferenceInfo", {
          reservationId: this.$route.query.reservation_id,
        });
      } else if (this.$route.query.room && this.$route.query.room.split("_").length >= 3) {
        this.$store.dispatch("findKarteReferenceInfo", {
          roomId: this.$route.query.room.split("_")[2],
        });
      }
    },
    fetchRoom() {
      this.$store.dispatch("findRoom", {
        roomId: this.$route.query.room.split("_")[2],
      });
    },
    postKarte: function () {
      this.$refs.body.updateKarte(this.$refs.body.karte).then(() => {
        if (this.karteUpdateResult == false) {
          // 保存エラー
          this.errorMessage =
            "カルテの保存に失敗しました。再読込して確認してください。";
        }
      });
      this.endEditing();
    },
    cancel: function () {
      this.endEditing();
      // 入力データをリセットする
      if (this.$route.query.reservation_id != null) {
        this.$store.dispatch("findKarte", {
          reservationId: this.$route.query.reservation_id,
        });
      }
    },
    startEditing: function () {
      resetSessionTimeoutActivity();
      this.editing = true;
    },
    endEditing: function () {
      resetSessionTimeoutActivity();
      this.editing = false;
    },
    isNotOperator: function () {
      return !this.hasAllCapabilities(["operator:access"]);
    },
    changeColorByTool: function () {
      switch (this.reservation.toolId) {
      case "line_tel":
        return "#FE5757";
      case "line_video":
        return "#11B621";
      case "tel":
        return "#FFB52B";
      default:
        return "#7F7F7F";
      }
    },
    viewableKarte: function () {
      if (this.reservation.date == null) return false;
      if (this.isNotOperator() && this.outOfDate()) {
        return false;
      } else {
        return true;
      }
    },
    outOfDate: function () {
      let reservationDate = new Date(this.reservation.originalDate);
      return reservationDate < this.viewLimitDateFrom;
    },
    toggleQuestionList() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss">
.karte {
  font-size: 14px;
}

// ナビゲーション・タブ(予約一覧/各ルーム)は常に画面上部に固定表示させるため、
// このページ自体はビューポート内(ナビ・タブの高さを除いた分)に高さを収め、
// はみ出す分は内部の各領域(v-row/チャット/サイドバー)でスクロールさせる
.karte-page {
  height: calc(100vh - 96px); /* 96px = compact TopMenu(48px) + Tab.vueのv-tabs(48px) */
  overflow: hidden;
}

// ボトムバーの上に来る領域（メインカラム + サイドバー）
.karte-content {
  flex: 1 1 auto;
  min-height: 0;
}

// KarteActionBarが表示される場合のみ、position: fixedで画面下端に固定されるバーの
// 高さ分(64px)を確保して本文がバーの下に隠れないようにする（非表示時に余白だけ残らないようにする）
.karte-content--with-action-bar {
  padding-bottom: 0;
}

.karte-container{
  height: 100%;
  overflow-y: auto;
  background-color: #fdeef3;
  padding-bottom: 0px;
  min-width: 0;
}

.karte-detail {
  background-color: #fff;
  border: 1px solid #e0e0e0;
}

.karte-scroll-area-y {
  height: 100%;
  overflow-y: auto;
}

.v-tooltip > .procedure-tooltip-content {
  background-color: #fff;
  border: 1px solid #000;
  color: #212121;
}

.procedure-tooltip-title {
  font-size: 15px;
}

// 運営からのお知らせ（v-htmlで描画）が長い英字やURLで親要素をはみ出さないよう、折り返しを強制する。
.karte-reference-content {
  word-break: break-word;
}
</style>
